import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../components/loader';
import FloatingLabelSelect from '../../components/floatingLabelSelect';
import { fetchInitialState, setOption, setOther, PROCESSING_PLAN_OPTIONS } from './processingPlanSlice';

const ProcessingPlan = () => {
  const processingPlanState = useSelector((state) => state.processing_plan);
  const dispatch = useDispatch();

  const { option, other } = processingPlanState.data;

  useEffect(() => {
    dispatch(fetchInitialState());
  }, [dispatch]);

  return (
    <>
      {processingPlanState.loading && <Loader />}
      <div className='mt-4 flex flex-col items-center justify-center px-1 sm:mt-10'>
        <h3 className="text-center text-2xl font-bold tracking-tight text-[#0a1445] sm:text-3xl">
          Processing plan
        </h3>
        <span className='mb-8 mt-2 text-center text-sm text-slate-500 sm:mb-10 sm:text-base'>
          Let us know how loans for this branch will be processed.
        </span>

        <form className="w-full max-w-md space-y-6">
          {/* Processing plan dropdown */}
          <div>
            <label htmlFor="processing-plan" className="mb-1.5 block text-sm font-semibold text-[#211b4f]">
              What is your processing plan? <span className="text-red-600">*</span>
            </label>
            {/* The browser draws a native <select>'s open list itself, so it could
                not be styled — this renders its own list with the same values. */}
            <FloatingLabelSelect
              id="processing-plan"
              name="processing-plan"
              label="What is your processing plan?"
              hideLabel
              placeholder="Select a processing plan"
              value={option}
              options={[{ value: '', label: 'Select a processing plan' }, ...PROCESSING_PLAN_OPTIONS]}
              handleChange={(e) => dispatch(setOption(e.target.value))}
            />
          </div>

          {/* "Please specify" — only shown and required when "Other" is selected */}
          {option === 'Other' && (
            <div>
              <label htmlFor="processing-plan-other" className="mb-1.5 block text-sm font-semibold text-[#211b4f]">
                Please specify <span className="text-red-600">*</span>
              </label>
              <input
                id="processing-plan-other"
                type="text"
                value={other}
                onChange={(e) => dispatch(setOther(e.target.value))}
                placeholder="Describe your processing plan"
                className="block h-12 w-full rounded-xl border border-slate-300 bg-white px-3 text-sm text-[#211b4f] shadow-sm transition-colors placeholder:text-slate-400 focus:border-[#fb6635] focus:outline-none focus:ring-1 focus:ring-[#fb6635]"
              />
            </div>
          )}
        </form>
      </div>
    </>
  );
};

export default ProcessingPlan;
